import React from 'react';
import { Card, Avatar, Button } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import { cn } from '../../../../utils/cn';
import { getInitials } from '../../../../utils/helper';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedHotLeadsCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className={cn("flex-shrink-0 font-semibold text-lg", record.originalData?.photo ? "" : "!bg-primary")}
                            src={record.originalData?.photo ?? ""}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.eventName && (
                                <p className="text-gray-500 text-sm mb-0 truncate" title={record.eventName}>
                                    Event: {record.eventName}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                </div>

                {/* Event Details Section */}
                <div className="space-y-3">
                    {/* Event Name */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventName?.trim() === "" ? "-" : record.eventName}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event Type:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventType ?? "-"}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event Date:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventDate ?? "-"}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Guest Count:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.guestCount ?? "-"}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Source:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.leadSource ?? "-"}
                        </span>
                    </div>


                    {/* Imported At */}
                    <div className="flex items-center justify-between pt-1 border-t border-gray-200 py-2">
                        <span className="text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Imported At:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.importedAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedHotLeadsCardView;
